import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-i_browser_full",
  "use": "icon-i_browser_full-usage",
  "viewBox": "0 0 34.02 34.02",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 34.02 34.02\" id=\"icon-i_browser_full\"><title>icon_画板</title><path d=\"M17,15.46a1.55,1.55,0,1,0,0,3.09,1.55,1.55,0,0,0,0-3.09Z\" /><path d=\"M17,3A14,14,0,1,0,31,17,14.07,14.07,0,0,0,17,3Zm8,6.58L20.15,20a.3.3,0,0,1-.19.19L9.56,25A.39.39,0,0,1,9,24.46l4.82-10.41a.44.44,0,0,1,.19-.19L24.46,9A.39.39,0,0,1,25,9.56Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol